export default {
  oportunidades: {
    method: "post",
    url: "api/relatorios/oportunidades",
    responseType: "blob",
  },
};
